import type React from 'react'
import type { FunctionComponent } from 'react'
import { Checkbox } from '@tomra/design-system-react/checkbox'
import { Label } from '@tomra/design-system-react/label'
import { charityStatusMap } from '../../../../../../lib/charity'
import { campaignStatusMap } from '../../../../../../lib/campaign'

const STATUS_MAP = { ...charityStatusMap, ...campaignStatusMap, NONE: 'No campaigns' }

type StatusType = CharityStatusType & CampaignStatusType

type Props = {
  label: string
  options: string[]
  filterKey: 'status' | 'campaignStatus'
  filter: CharityFilterType
  setFilter: React.Dispatch<React.SetStateAction<CharityFilterType>>
}

export const CharityStatusSelect: FunctionComponent<Props> = ({ label, options, filterKey, filter, setFilter }) => {
  function updateFilter(value: string) {
    setFilter(prevState => {
      const state = prevState[filterKey] as StatusType[]

      if (state && state.includes(value as StatusType)) {
        return {
          ...prevState,
          [filterKey]: state.filter(item => item !== value)
        }
      }

      return {
        ...prevState,
        [filterKey]: [...(state || []), value]
      }
    })
  }

  return (
    <fieldset>
      <legend className="label">{label}</legend>
      <div className="grid gap-sm">
        {options.map(key => (
          <div key={`cs-${key}`} className="flex items-center gap-sm">
            <Checkbox
              id={`cs-${filterKey}-${key}`}
              checked={filter[filterKey]?.includes(key as StatusType)}
              onCheckedChange={() => updateFilter(key)}
            />
            <Label htmlFor={`cs-${filterKey}-${key}`} className="cursor-pointer text-midnight">
              {STATUS_MAP[key as keyof typeof STATUS_MAP] || key}
            </Label>
          </div>
        ))}
      </div>
    </fieldset>
  )
}
